import { jsx as t } from "react/jsx-runtime";
import { createContext as s, createRef as f, useRef as a, useMemo as u, useContext as w } from "react";
import { useInView as R } from "react-intersection-observer";
const i = s({
  containerRef: f(),
  inViewRef: () => {
  },
  inView: !1
}), V = ({ children: o }) => {
  const n = a(null), { ref: r, inView: e } = R(), c = u(
    () => ({ containerRef: n, inViewRef: r, inView: e }),
    [n, r, e]
  );
  return /* @__PURE__ */ t(i.Provider, { value: c, children: o });
}, m = (o) => {
  const { containerRef: n, inViewRef: r } = w(i);
  return /* @__PURE__ */ t(
    "div",
    {
      ref: (e) => {
        n.current = e, r(e);
      },
      ...o
    }
  );
}, x = V, l = m;
export {
  V as BannerProvider,
  i as BannerProviderContext,
  m as BannerViewport,
  x as Provider,
  l as Viewport
};
